import { Analysis } from 'common-spectrum';
import { appendedParser } from 'ndim-parser';
import { appendUnits, getDensities } from './utils';
const metaVarHeaders = [
    'Analysis.Setup.Vector.Graph.XAxis',
    'Analysis.Setup.Vector.Graph.YAxis',
    'Analysis.Setup.Vector.List.Datum',
    'Function.User',
];
export function metaUnits(meta) {
    let knownUnits = {};
    for (const key of metaVarHeaders) {
        const keyName = `${key}.${"Name" /* name */}`;
        const keyUnits = `${key}.${"Unit" /* units */}`;
        if (meta[keyName] && meta[keyUnits]) {
            const names = meta[keyName].split(',');
            const units = meta[keyUnits].split(',');
            for (let index = 0; index < names.length; index++) {
                const [label] = getDensities(names[index]);
                if (label === 'Q_dens') {
                    // TODO the existing parser doesn't recognize electron charge units
                    knownUnits[label] = 'uC/mm';
                }
                else {
                    knownUnits[label] = units[index];
                }
            }
        }
    }
    return knownUnits;
}
export default class BaseB1505 {
    constructor(xLabel, yLabel, scale) {
        this.xLabel = xLabel;
        this.yLabel = yLabel;
        this.scale = scale;
    }
    parseMeta(meta) {
        if (!meta)
            return {};
        let ans = {};
        for (const key in meta) {
            ans[key] = meta[key]
                .split(',')
                .filter((val) => val !== '')
                .join(',');
        }
        // add default kind scale
        const { xLabel, yLabel, scale } = this;
        ans['default.xLabel'] = xLabel;
        ans['default.yLabel'] = yLabel;
        ans['default.scale'] = scale;
        return ans;
    }
    parseText(text) {
        const series = appendedParser(text);
        let analyses = [];
        for (const { data, meta } of series) {
            const parsedMeta = this.parseMeta(meta);
            const knownUnits = metaUnits(meta);
            let analysis = new Analysis();
            analysis.pushSpectrum(appendUnits(data, knownUnits), {
                title: parsedMeta.Remarks ||
                    parsedMeta['TestRecord.Remarks'] ||
                    parsedMeta['Device ID'] ||
                    parsedMeta['Setup title'] ||
                    parsedMeta.SetupTitle,
                meta: parsedMeta,
            });
            analyses.push(analysis);
        }
        return analyses;
    }
}
//# sourceMappingURL=data:application/json;base64,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